/* r26-global: footer F4 newsletter, the chosen disciplines become customer tags (25/10). */
(function () {
  var form = document.querySelector('[data-f4-news]');
  if (!form) return;
  var tags = form.querySelector('[data-f4-tags]');
  if (!tags) return;
  var base = tags.value;
  form.addEventListener('submit', function () {
    var picked = Array.prototype.map.call(form.querySelectorAll('[data-f4-disc]:checked'), function (c) { return c.value; });
    tags.value = picked.length ? base + ',' + picked.join(',') : base;
  });
})();
